// extracted by mini-css-extract-plugin
module.exports = {"simple_page":"SimplePage_simple_page__mekHQ"};